export const agentName = {
    quick_answer_suggestor: "quick_answer_suggestor",
    evs_expert: "evs_expert", 
    doc_reviewer: "doc_reviewer",
    questionnaire_uploader: "questionnaire_uploader",
    cdp_expert: "cdp_expert",
} as const;

export type AgentName = (typeof agentName)[keyof typeof agentName];
